function reff() {
    if (window.location.hash === '#login-referrer') {
        document.querySelector('[data-login="open-notice-link"]').dispatchEvent(new Event('click'))
    }
}